import React from "react";

const LinkButton = ({ callback, text, icon, styles = {}, classnames = "" }) => {
  return (
    <button
      onClick={callback}
      style={styles}
      className={`link-button mb-2 mx-auto ${classnames}`}
    >
      <small>{text}</small>
      {icon}
    </button>
  );
};

export default LinkButton;
